var lib_core = require("lib-core");
var PosData = require("./posData.js");
var cio_config = require("cio-config");

var PosAngleData = {
    addPosAngle: function (pos, angle){
        this.addPos(pos);

        this.angle = this.value("angle", true, cio_config.types.float.validator);
        if(angle != undefined) this.angle(angle);
    }
};
lib_core.extend(PosAngleData, PosData);

PosAngleData.rotate = function(angle, center) {
    PosData.rotate.call(this, angle, center);
    this.angle((this.angle() + angle)%360);
};

PosAngleData.flip = function(flipLine) {
    PosData.flip.call(this, flipLine);
    var flipAngle = flipLine.dir.angleDegrees()-this.angle();
    this.angle((this.angle()+flipAngle*2)%360);
};

PosAngleData.getTransform = function() {
    var transform = PosData.getTransform.call(this);
    transform.angle = this.angle();
    return transform;
};

module.exports = PosAngleData;
